/** Shared nickname length limit for Settings /me/profile editors. */
export const DISPLAY_NAME_MAX = 20
